module.exports = "https://dev.stanwinstonschool.com/logo-talpor.331bbccc605ffd5380ddbe5fd610b2bd.svg";